<template>
  <div>
    <div class="caption grey--text font-weight-bold mb-3 nowrap">
      {{ label }}
      <slot name="label"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ReviewCardInfoItem',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.nowrap {
  white-space: nowrap;
}
</style>
